(() => {
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const init = scope => {
    const videos = scope.matches?.('video') ? [scope] : [...scope.querySelectorAll?.('video') || []];
    videos.forEach(video => {
      if (video.dataset.masterMediaReady === 'true') return;
      video.dataset.masterMediaReady = 'true';
      video.setAttribute('playsinline', '');

      if (!video.hasAttribute('autoplay')) return;

      if (reducedMotion) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        video.controls = true;
        return;
      }

      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            const play = entry.target.play();
            if (play?.catch) play.catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, {threshold: [0, .25, .75]});
      observer.observe(video);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();